export default {
  message: {
    title: '',
    preferVisitRead: '',
    preferVisitListten: '',
    preferVisitComplete: 'Completa',
    preferVisitShort: 'Curta',
    preferVisitSignoguia: 'Signoguia',
    titleVisitType: 'Visites guiades',
    titleMenu: 'Menú',
    moreInfo:'Saber-ne més?',
    moreInfoNo: 'No',
    moreInfoYes:'Sí',
    downloadAudio: '(Descàrrega d\'àudios)',
    download: 'Descàrrega dels arxius',
    downloadVideo: '(Descàrrega de videos)',
    downloadSignoguia: 'Descàrrega dels arxius de video',
    errorDownload: 'Hi ha hagut un error en la descàrrega. Torna a intentar-ho',
    cancelDownload: 'Has cancel·lat la descàrrega.',
    retry: 'Reintentar',
    noConnection: 'No tens conexió a internet',
    titleMap: 'TRIEU UN NÚMERO',
    map: 'mapa_cat.png',

    initDownload: 'Si us plau, esperi mentre es descarreguen els àudios.',
    endDownload: 'Àudios descarregats. Gaudeixi de la visita!',



    menuItems: [
        {
            img: '1a.jpg',
            imageMenu: '',
            title: ' PREMEU PLAY',
            author: '',
            description: '',
            audio: '1.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '1a.jpg',
                    second: '0'
                },
                {
                    img: '1b.jpg',
                    second: '46'
                },
            ],
        },
        {
            img: '2.jpg',
            imageMenu: '',
            title: '2. PURIFICACIÓ',
            author: '',
            description: '',
            audio: '2.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '3.jpg',
            imageMenu: '',
            title: '3. CONDEMNA',
            author: '',
            description: '',
            audio: '3.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '4.jpg',
            imageMenu: '',
            title: '4. CAIGUDA',
            author: '',
            description: '',
            audio: '4.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '5.jpg',
            imageMenu: '',
            title: '5. MARC',
            author: '',
            description: '',
            audio: '5.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '6.jpg',
            imageMenu: '',
            title: '6. LLUC',
            author: '',
            description: '',
            audio: '6.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '7.jpg',
            imageMenu: '',
            title: '7. TOMÀS',
            author: '',
            description: '',
            audio: '7.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '8a.jpg',
            imageMenu: '',
            title: '8. JAUME EL MENOR',
            author: '',
            description: '',
            audio: '8.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '8a.jpg',
                    second: '0'
                },
                {
                    img: '8b.jpg',
                    second: '65'
                },
            ],
        },
        {
            img: '9.jpg',
            imageMenu: '',
            title: '9. JAUME EL MAJOR',
            author: '',
            description: '',
            audio: '9.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '10a.jpg',
            imageMenu: '',
            title: '10. FELIP',
            author: '',
            description: '',
            audio: '10.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '10a.jpg',
                    second: '0'
                },
                {
                    img: '10b.jpg',
                    second: '57'
                },
            ],
        },
        {
            img: '11.jpg',
            imageMenu: '',
            title: '11. ANDREU',
            author: '',
            description: '',
            audio: '11.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '12.jpg',
            imageMenu: '',
            title: '12. BARTOMEU',
            author: '',
            description: '',
            audio: '12.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '13.jpg',
            imageMenu: '',
            title: '13. PERE I PAU',
            author: '',
            description: '',
            audio: '13.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '14a.jpg',
            imageMenu: '',
            title: '14. SIMÓ I JUDES',
            author: '',
            description: '',
            audio: '14.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '14a.jpg',
                    second: '0'
                },
                {
                    img: '14b.jpg',
                    second: '21'
                },
                {
                    img: '14c.jpg',
                    second: '39'
                },
            ],
        },
        {
            img: '15.jpg',
            imageMenu: '',
            title: '15. JOAN ',
            author: '',
            description: '',
            audio: '15.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '16.jpg',
            imageMenu: '',
            title: '16. MATEU',
            author: '',
            description: '',
            audio: '16.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '17.jpg',
            imageMenu: '',
            title: '17. PECAT',
            author: '',
            description: '',
            audio: '17.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '18.jpg',
            imageMenu: '',
            title: '18. MORT',
            author: '',
            description: '',
            audio: '18.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '19.jpg',
            imageMenu: '',
            title: '19. GUERRA',
            author: '',
            description: '',
            audio: '19.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '20.jpg',
            imageMenu: '',
            title: '20. PARADÍS TANCAT',
            author: '',
            description: '',
            audio: '20.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '21a.jpg',
            imageMenu: '',
            title: '21. CRUCIFIXIÓ',
            author: '',
            description: '',
            audio: '21.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '21a.jpg',
                    second: '0'
                },
                {
                    img: '21b.jpg',
                    second: '136'
                },
            ],
        },
        {
            img: '22.jpg',
            imageMenu: '',
            title: '22. ENTERRAMENT',
            author: '',
            description: '',
            audio: '22.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '23.jpg',
            imageMenu: '',
            title: '23. ASCENSIÓ',
            author: '',
            description: '',
            audio: '23.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '24.jpg',
            imageMenu: '',
            title: '24. MARC',
            author: '',
            description: '',
            audio: '24.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '25.jpg',
            imageMenu: '',
            title: '25. LLUC',
            author: '',
            description: '',
            audio: '25.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '26.jpg',
            imageMenu: '',
            title: '26. JOAN ',
            author: '',
            description: '',
            audio: '26.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '27.jpg',
            imageMenu: '',
            title: '27. MATEU',
            author: '',
            description: '',
            audio: '27.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '28.jpg',
            imageMenu: '',
            title: '28. ESPAI SERT',
            author: '',
            description: '',
            audio: '28.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '29a.jpg',
            imageMenu: '',
            title: '29. PINTURES',
            author: '',
            description: '',
            audio: '29.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '29a.jpg',
                    second: '0'
                },
                {
                    img: '29b.jpg',
                    second: '65'
                },
            ],
        },
        {
            img: '30.jpg',
            imageMenu: '',
            title: '30. MAQUETA',
            author: '',
            description: '',
            audio: '30.mp3',
            video: '',
            visitType: '{all}',
        },

        {
            img: '31.jpg',
            imageMenu: 'thumb_2.png',
            title: 'Crèdits',
            author: '',
            description: 'Guió, producció, disseny i programació: Trama Media.<br><br>Agraïments: Bisbat de Vic.<br><br>Fotografies: Pepo Segura, Guillem Mercadal, MNAC, CRBMC.<br><br>Textos bíblics: <i>La Bíblia. Traducció Interconfessional</i> (BCI). Associació Bíblica de Catalunya, Centre de Pastoral Litúrgica de Barcelona, Editorial -Claret, Societat Bíblica. Barcelona, 2011.<br><br>Altres textos: Josep Torras i Bages, <i>La ciència del patir.</i> Foment de la Pietat Catalana, Barcelona, 1927.<br><br>Trama Media ha fet tots els possibles per obtenir les autoritzacions necessàries per a tots els continguts reproduïts en aquesta guia. Això no obstant, si voleu formular alguna reclamació relativa a la propietat intel·lectual, no dubteu a posar-vos en contacte amb nosaltres.<br><br>© de les fotografies i els textos citats: els autors.<br>© de la resta: Trama Media.<br><br>',
            audio: '',
            visitType: '{all}',
            moreInfoItem: '',
            isCredits: true,

        }
    ]
  },
}



// WEBPACK FOOTER //
// ./src/data/i18n/catala.js